import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitInputsArea.module.scss';

const TextArea = ({
  id = '',
  name = '',
  className = '',
  maxLength = null,
  minLength = 0,
  placeholder = '',
  value = '',
  onChange = null,
  ref = null,
  isDisabled = null,
  isReadOnly = false,
  isRequired = false,
  isError = false,
  testId = '',
  inputTestId = '',
}) => (
  <div
    className={classnames(styles.element, { [styles.isError]: isError }, className)}
    data-testid={testId}
  >
    <textarea
      id={id}
      className={className}
      name={name}
      maxLength={maxLength}
      minLength={minLength}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      ref={ref}
      value={value}
      disabled={isDisabled}
      readOnly={isReadOnly}
      required={isRequired && !isReadOnly && !isDisabled}
      data-testid={inputTestId}
    />
  </div>
);

TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  isError: PropTypes.bool,
  testId: PropTypes.string,
  inputTestId: PropTypes.string,
};

export { TextArea as TextAreaStorybook };
export default React.memo(TextArea);
